import { ExtractRouteParams } from "@CommonUtils/routes";

export const RoutePutCategories_categoryId_Status = "/categories/:categoryId/status";

export type ParamsPutCategories_categoryId_Status = ExtractRouteParams<
  typeof RoutePutCategories_categoryId_Status
>;

export interface PayloadPutCategories_categoryId_Status {
  status: "ACTIVE" | "ARCHIVED";
}
